import Header from './Header';
import Footer from './Footer';
import RouteSeo from '../seo/RouteSeo';

const Layout = ({ children }) => {
  return (
    <div>
      <RouteSeo />
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
